import React from "react";
import { SnackbarProvider, useSnackbar } from "notistack";

export const SnackbarProviderWrapper = ({ children }) => (
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    preventDuplicate
  >
    {children}
  </SnackbarProvider>
);

export const useCustomSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showToast = ({ type, message }) => {
    enqueueSnackbar(message, { variant: type });
  };

  return showToast;
};
